
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"gst-svg-icon",attrs:{"d":"M1.5 23.463l.886-2.662a.5.5 0 01.474-.342h18.28a.5.5 0 01.474.342l.886 2.658","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M3.5 9.463h17v11h-17v-11zm20 14H.5m6.002-14v11m3-11v11m5-11v11m3-11v11M22.37 6.85a.5.5 0 00-.226-.592L12.248.6a.5.5 0 00-.5 0l-9.9 5.655a.5.5 0 00-.226.592l.764 2.273a.5.5 0 00.474.342h18.28a.5.5 0 00.474-.342l.756-2.269zm-.037-.388H1.663","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    